// extracted by mini-css-extract-plugin
module.exports = {"separatedNamesHolder":"FirstLastNameInputs_separatedNamesHolder__31eWS","separatedNamesItem":"FirstLastNameInputs_separatedNamesItem__3gl_g"};